import {
  ArrowRight,
  ArrowUpRight,
  PackageCheck,
  TimerReset,
  Utensils,
} from "lucide-react";
import recipeData from "../data/demo-recipes.json";
import type { LiveSnapshot } from "../types";

function stationLabel(stationId: string, snapshot: LiveSnapshot) {
  return snapshot.stations.find((station) => station.id === stationId)?.label ?? stationId;
}

export function TasksView({ snapshot }: { snapshot: LiveSnapshot }) {
  return (
    <main className="content-page">
      <header className="content-heading">
        <span>LIVE OPERATIONS</span>
        <h1>From prep to pass</h1>
        <p>Confirmed tickets and anticipatory work share one operating timeline.</p>
      </header>

      <section className="task-timeline">
        <article>
          <time>NOW</time>
          <div className="timeline-icon hot"><Utensils size={19} /></div>
          <div>
            <h2>Jajangmyeon sauce - Gas Range</h2>
            <p>Worker B sauteing vegetables - expected completion in 2m 14s</p>
          </div>
          <strong>72%</strong>
        </article>
        <article>
          <time>+03:00</time>
          <div className="timeline-icon"><PackageCheck size={19} /></div>
          <div>
            <h2>Dice vegetables for 12 Jajangmyeon</h2>
            <p>8 Actian episodes - Pioneer recommendation confidence 87%</p>
          </div>
          <strong>READY</strong>
        </article>
        <article>
          <time>+12:00</time>
          <div className="timeline-icon"><TimerReset size={19} /></div>
          <div>
            <h2>Tangsuyuk and Jjamppong peak forecast</h2>
            <p>Pre-mix batter - reserve one fryer basket and two range burners</p>
          </div>
          <strong>FORECAST</strong>
        </article>
      </section>

      <section className="recipe-section">
        <div className="section-title">
          <div>
            <span>DEMO MENU</span>
            <h2>Recipe action graphs</h2>
          </div>
          <small>{recipeData.recipes.length} recipes validated against station capabilities</small>
        </div>
        <div className="recipe-list">
          {recipeData.recipes.map((recipe) => {
            const stationPath = Array.from(
              new Set(recipe.actions.map((action) => stationLabel(action.station, snapshot))),
            );
            return (
              <article key={recipe.dish}>
                <div>
                  <strong>{recipe.dish}</strong>
                  <span>{recipe.actions.length} dependent actions</span>
                </div>
                <div className="recipe-path">
                  {stationPath.map((station, index) => (
                    <span key={station}>
                      {station}
                      {index < stationPath.length - 1 ? <ArrowRight size={13} /> : null}
                    </span>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <section className="inventory-section">
        <div className="section-title">
          <div>
            <span>INVENTORY</span>
            <h2>Prep inventory</h2>
          </div>
          <button type="button">View all <ArrowUpRight size={16} /></button>
        </div>
        <div className="inventory-table">
          {snapshot.inventory.map((item) => {
            const percent = Math.round((item.current / item.target) * 100);
            return (
              <div className="inventory-line" key={item.id}>
                <strong>{item.name}</strong>
                <div><i style={{ width: `${Math.min(100, percent)}%` }} /></div>
                <span>{item.current} / {item.target}{item.unit}</span>
                <em>{percent < 45 ? "PREP NEEDED" : "STABLE"}</em>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
